<template>
  <div class="container">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="box">
          <img class="image logo" src="../assets/logo1.png" alt="Me Want Food"> 
          <div class="notification is-danger" v-if="flash">{{flash}}</div>
          <form v-on:submit.prevent="submit">
            <div class="field">
              <p class="control has-icons-left">
                <input v-model="form.email" ref="username" class="input" type="email" placeholder="Email">
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope" />
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control has-icons-left">
                <input v-model="form.password" ref="password" class="input" type="password" placeholder="Password">
                <span class="icon is-small is-left">
                  <i class="fas fa-lock" />
                </span>
              </p>
            </div>
            <div class="field is-grouped">
              <div class="control">
                <button class="button is-success" type="submit">
                  Login
                </button>
              </div>
              <div class="control">
                <button class="button is-text" type="button" @click="onRegister">
                  Sign Up
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../utils/auth';

export default {
  name: 'login',
  props: {
    message: Object,
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
      },
      flash: null,
    };
  },
  created() {
    if (this.message) {
      this.flash = this.message.message;
    }
  },
  mounted() {
    this.$nextTick(() => this.focus('username'));
  },
  methods: {
    submit() {
      const form = {
        username: this.form.email.slice(0),
        password: this.form.password.slice(0),
      };

      this.form.password = null;
      this.flash = null;

      // TODO show loading message
      login(form)
      .then(() => this.$router.push({ name: 'browse' }))
      .catch((error) => {
        this.flash = error.message;
        this.focus(error.field);
      });
    },
    onRegister() {
      this.$router.push({ name: 'register' });
    },
    focus(field) {
      const el = this.$refs[field];
      if (el) {
        el.focus();
        el.select();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.logo
  display: block
  margin-left: auto
  margin-right: auto
  padding-bottom: 2.5rem
</style>



// WEBPACK FOOTER //
// src/components/Login.vue